var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/img/logo.png","alt":""}})])],1),_c('div',{staticClass:"login-wrapper"},[_c('div',{staticClass:"form-wrapper"},[_c('router-view')],1)]),_c('FooterLogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }